import {MapGlyph} from './MapGlyph';
import React from 'react';
import {Pressable,View} from 'react-native';
import {useTokens} from './delivered/theme/tokens';
import {mapControlStyle} from './MapControls';

// Only the route-history renderer mounts these controls. Releasing the camera
// leaves the marker, playback cursor and route geometry untouched.
export function MapFollowControls({locale,following,disabled=false,onChange}:{locale:'da-DK'|'en-GB';following:boolean;disabled?:boolean;onChange:(follow:boolean)=>void}){
 const {colors}=useTokens(),da=locale==='da-DK';
 const ink=following?'#FFFFFF':colors.primary;
 return <View pointerEvents="box-none" style={{position:'absolute',top:68,left:12,zIndex:20}}>
  <Pressable testID="map-follow-toggle" accessibilityRole="button" accessibilityLabel={following?(da?'Slip markør':'Release marker'):(da?'Følg markør':'Follow marker')} accessibilityState={{selected:following,disabled}} aria-pressed={following} disabled={disabled} onPointerDown={e=>e.stopPropagation()} onPress={()=>onChange(!following)} style={[mapControlStyle,{backgroundColor:following?'#1F5D8F':colors.surface,borderColor:colors.border,opacity:disabled?.45:1}]}>
   <View accessible={false} pointerEvents="none" style={{width:30,height:30,alignItems:'center',justifyContent:'center'}}>
    <MapGlyph name="pin" color={ink}/>
   </View>
  </Pressable>
 </View>;
}
